import { IMerchantsCount } from './EvoSalesPortalModel';

export class MerchantsCountNullObject implements IMerchantsCount {
	ActiveMerchantCount: number = null;
	OpenMerchantCount: number = null;
	AttritionPercentage: number = null;
	PCICompliance: number = null;
}
